var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgMoodmeterSettingsIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.802 11.24c-2.424-1.373-4.396-4.724-4.396-7.47 0-2.746 1.97-3.864 4.395-2.491 2.423 1.372 4.396 4.723 4.397 7.47-.001 2.746-1.972 3.865-4.396 2.49Z",
    fill: "#009983"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.075 8.819c0-2.747-1.973-6.098-4.396-7.471-1.163-.658-2.22-.743-3.007-.352V.991l-1.056.595.322.111c-.34.514-.532 1.213-.532 2.072.001 2.746 1.972 6.096 4.396 7.47.727.41 1.412.598 2.017.585l.043.303 1.043-.589-.005-.002c.729-.475 1.175-1.412 1.175-2.717Z",
    fill: "url(#moodmeter-settings-icon_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.73 11.845c-2.424-1.373-4.395-4.724-4.396-7.47-.001-2.746 1.97-3.864 4.393-2.491 2.425 1.373 4.397 4.723 4.398 7.47.001 2.746-1.97 3.864-4.395 2.49Z",
    fill: "#6BC36C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.588 1.963c-1.178-.667-2.248-.745-3.038-.336-.753.468-1.215 1.417-1.215 2.748 0 2.746 1.972 6.097 4.396 7.47 1.178.667 2.25.745 3.04.336.752-.468 1.214-1.417 1.214-2.747 0-2.747-1.973-6.098-4.397-7.47Z",
    fill: "url(#moodmeter-settings-icon_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.395 10.373c-1.028-.582-1.997-1.737-2.657-3.167a.512.512 0 0 1-.051-.29c.013-.083.058-.139.125-.154a.252.252 0 0 1 .177.036c.1.057.194.165.25.289.544 1.177 1.33 2.12 2.156 2.588.827.469 1.613.415 2.157-.147.056-.059.15-.062.25-.005a.664.664 0 0 1 .302.461c.014.1-.005.182-.051.23-.66.684-1.627.742-2.658.159ZM15.558 5.18c0 .613-.311.934-.697.716-.384-.217-.697-.892-.697-1.505 0-.614.313-.935.697-.717.385.216.697.89.697 1.505ZM18.624 6.914c0 .613-.312.935-.695.717-.385-.218-.697-.892-.697-1.505 0-.615.31-.935.697-.718.383.218.695.893.695 1.506Z",
    fill: "#6BC36C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.053 10.216c.047-.05.066-.131.051-.23a.696.696 0 0 0-.125-.297.581.581 0 0 0-.177-.163.288.288 0 0 0-.065-.029l-.01.008a1.468 1.468 0 0 1-.952.458c-.419.084-.893-.009-1.38-.285-.826-.47-1.612-1.412-2.155-2.589a.65.65 0 0 0-.251-.288.316.316 0 0 0-.066-.029.198.198 0 0 0-.059.121.51.51 0 0 0 .051.29c.66 1.43 1.629 2.583 2.658 3.167.542.306 1.067.436 1.538.39.353-.072.673-.246.942-.524ZM14.862 3.672a.504.504 0 0 0-.192-.064c-.197.085-.328.358-.328.756 0 .614.312 1.288.697 1.507.067.037.13.058.191.064.197-.085.329-.358.329-.756 0-.614-.313-1.288-.697-1.507ZM17.927 5.408a.49.49 0 0 0-.192-.064c-.197.085-.328.358-.328.756 0 .614.313 1.288.697 1.505a.497.497 0 0 0 .192.065c.197-.085.328-.358.328-.756-.002-.613-.313-1.288-.697-1.506Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.59 38.631c-2.424-1.373-4.396-4.724-4.396-7.47-.002-2.746 1.97-3.864 4.394-2.491 2.424 1.373 4.396 4.724 4.398 7.47-.002 2.746-1.973 3.864-4.396 2.491Z",
    fill: "#2E2E2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.862 36.21c-.001-2.747-1.972-6.098-4.397-7.47-1.162-.659-2.22-.744-3.007-.352v-.005l-1.056.596.323.11c-.34.513-.533 1.212-.533 2.073 0 2.745 1.972 6.096 4.396 7.469.726.41 1.412.599 2.017.586l.045.303 1.043-.59s-.003 0-.005-.002c.728-.476 1.174-1.412 1.174-2.718Z",
    fill: "#62007A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.374 29.354c-1.177-.667-2.248-.746-3.038-.336-.753.467-1.215 1.416-1.215 2.747.001 2.745 1.972 6.097 4.396 7.469 1.179.667 2.25.745 3.038.336.753-.468 1.215-1.417 1.215-2.747.002-2.746-1.972-6.096-4.396-7.47Z",
    fill: "#2E2E2E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.346 32.57c0 .613-.311.934-.697.716-.384-.217-.697-.892-.697-1.505 0-.613.311-.935.696-.716.386.216.698.89.698 1.504ZM19.41 34.305c0 .615-.313.935-.697.718-.385-.218-.697-.893-.697-1.506 0-.614.311-.935.697-.717.384.218.697.891.697 1.505ZM19.446 37.89c0 .235-.168.33-.374.212l-3.78-2.14a.81.81 0 0 1-.374-.637c0-.234.168-.33.373-.212l3.781 2.14a.813.813 0 0 1 .374.638Z",
    fill: "#62007A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.649 31.064a.498.498 0 0 0-.201-.067c-.192.09-.319.36-.319.752 0 .615.313 1.288.697 1.506.07.04.136.06.2.065.192-.089.32-.36.32-.752 0-.613-.313-1.286-.697-1.504ZM18.713 32.8a.501.501 0 0 0-.2-.067c-.192.089-.32.36-.32.752 0 .614.313 1.288.697 1.505.07.04.137.06.2.066.192-.089.32-.36.32-.752 0-.613-.313-1.287-.697-1.504ZM19.072 37.253l-3.78-2.14a.366.366 0 0 0-.108-.043c-.056.043-.09.12-.09.224a.81.81 0 0 0 .375.637l3.78 2.14a.366.366 0 0 0 .108.042c.056-.042.09-.12.09-.224a.812.812 0 0 0-.375-.636Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.604 25.02c-2.424-1.374-4.396-4.724-4.396-7.47-.002-2.747 1.97-3.865 4.395-2.492 2.423 1.373 4.396 4.724 4.397 7.47-.001 2.746-1.972 3.864-4.396 2.491Z",
    fill: "#B91900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 22.598c0-2.747-1.972-6.098-4.397-7.47-1.161-.659-2.22-.744-3.006-.352v-.005l-1.056.595.323.11c-.34.514-.533 1.214-.533 2.073 0 2.745 1.973 6.096 4.397 7.469.727.41 1.412.599 2.017.586.024.175.044.302.044.302l1.043-.588s0-.002-.005-.003c.729-.475 1.175-1.411 1.173-2.717Z",
    fill: "#FF0082"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.532 25.623c-2.424-1.373-4.396-4.724-4.396-7.47 0-2.746 1.97-3.864 4.395-2.491 2.425 1.373 4.396 4.724 4.397 7.47-.001 2.746-1.971 3.864-4.396 2.491Z",
    fill: "#FA6766"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.389 15.742c-1.177-.667-2.248-.746-3.038-.336-.753.467-1.215 1.416-1.215 2.747 0 2.745 1.972 6.096 4.396 7.469 1.178.667 2.25.745 3.04.336.751-.467 1.214-1.417 1.214-2.747-.001-2.745-1.973-6.096-4.397-7.47Z",
    fill: "#FF0082"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.196 21.538c.962.545 1.867 1.623 2.483 2.958a.477.477 0 0 1 .048.27c-.013.08-.055.13-.116.145a.227.227 0 0 1-.166-.035.607.607 0 0 1-.235-.27c-.506-1.1-1.241-1.98-2.014-2.419-.773-.438-1.507-.387-2.013.138-.054.056-.142.058-.235.005a.526.526 0 0 1-.165-.153.609.609 0 0 1-.117-.277c-.013-.092.004-.17.048-.215.616-.637 1.52-.691 2.482-.147ZM16.36 18.957c0 .615-.312.935-.697.718-.384-.218-.696-.893-.696-1.506 0-.614.312-.935.696-.717.385.218.696.891.697 1.505ZM19.424 20.693c0 .614-.312.935-.696.718-.385-.218-.697-.893-.697-1.507 0-.614.312-.935.697-.718.384.22.696.893.696 1.507Z",
    fill: "#FB7070"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.196 21.538c-.52-.295-1.024-.413-1.475-.36-.311.07-.592.23-.83.476-.044.047-.062.122-.05.215.014.093.056.19.118.277a.54.54 0 0 0 .165.153c.02.012.04.02.058.026a1.37 1.37 0 0 1 .844-.422c.404-.1.868-.017 1.346.255.771.438 1.506 1.318 2.014 2.418a.613.613 0 0 0 .235.27.43.43 0 0 0 .056.025.192.192 0 0 0 .05-.104.476.476 0 0 0-.048-.27c-.616-1.336-1.521-2.414-2.483-2.959ZM15.663 17.452a.48.48 0 0 0-.2-.066c-.19.089-.318.36-.318.752 0 .614.312 1.288.697 1.505.07.04.136.061.2.066.192-.089.32-.36.32-.752-.003-.614-.314-1.288-.699-1.505ZM18.728 19.187a.476.476 0 0 0-.201-.066c-.192.089-.319.36-.319.752 0 .614.312 1.288.697 1.505.07.039.136.06.2.066.192-.089.32-.36.32-.752 0-.613-.313-1.287-.697-1.505Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.286 13.44c1.94 1.044 4.458 2.465 5.768.143.486-.863 1.363-2.117 1.657-3.036.197-.613.497-2.734 1.601-1.643.4.396.247 1.12.3 1.621.132-.045.413-.144.524-.06.295.22-.627.882-.908 1.09-2.148 4.457-2.48 5.837-5.347 5.997-.183.01-2.231-.369-2.662-.53a3.419 3.419 0 0 1-.83-.482c-.444-.334-.478-.937-.965-1.251",
    fill: "url(#moodmeter-settings-icon_svg__c)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 45.782s-.195.639-.253.877c-.036.145.038.54.1.821a.508.508 0 0 0 .38.383c.344.08.706.017.999-.178l2.674-1.772a.322.322 0 0 0 .108-.425l-.072-.134a.525.525 0 0 0-.592-.257c-.604.15-1.729.401-2.127.3-.556-.14-1.217.385-1.217.385Z",
    fill: "#00AF9B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.293 43.88s.008 1.878.081 2.14c.074.262.942.253 1.176-.31.198-.48.307-2.04.307-2.04l-1.564.21Z",
    fill: "url(#moodmeter-settings-icon_svg__d)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.771 46.831s-.269.613-.355.842c-.053.14-.025.541.004.828.02.192.148.357.333.424.332.118.7.097 1.013-.064l2.865-1.457a.326.326 0 0 0 .157-.41l-.055-.141a.53.53 0 0 0-.559-.325c-.618.081-1.763.204-2.147.058-.538-.202-1.256.245-1.256.245Z",
    fill: "#00AF9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.683 45.08s-.148 1.87-.098 2.139c.05.267.919.328 1.198-.217.236-.46.475-2.006.475-2.006l-1.575.084Z",
    fill: "url(#moodmeter-settings-icon_svg__e)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M.328 25.098s.91 7.365.596 9.311c-.596 3.688.14 9.472.14 9.472.673.41 1.376.408 1.93 0 0 0 .87-12.295 2.429-14.904V24.84l-2.075-2.223-2.233-.387c-.682.294-.914 2.148-.787 2.868Z",
    fill: "#2E2E2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22 24.243s-.357 5.024-1.1 10.076c-.7 4.754-1.783 9.508-1.938 10.904a.695.695 0 0 1-.316.51c-.236.156-.617.302-1.145.197a.463.463 0 0 1-.367-.409c-.161-1.55-.247-8.621-.241-9.898.005-1.44-1.256-9.94-1.256-9.94l.41-3.453 5.953 2.013Z",
    fill: "#2E2E2E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.038 10.192s3.963 3.281 3.182 5.81c-1.147 3.717.88 10.008.9 11.54a.217.217 0 0 1-.245.218c-.262-.03-.639-.237-.655-1.164 0 0 .259 1.598-.875 2.015-1.133.416-5.981.698-7.703-.552 0 0-1.613-1.977.274-6.846 2.133-5.501-2.106-7.778.524-10.915.893-1.064 2.194-1.283 4.598-.106Z",
    fill: "#00AF9B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m6.561 7.86-.245 2.332a.408.408 0 0 1-.344.357 2.513 2.513 0 0 1-1.847-.402.725.725 0 0 1-.293-.781l.438-1.72 2.291.214Z",
    fill: "url(#moodmeter-settings-icon_svg__f)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.774 4.064s.46 2.937.158 3.714c-.3.776-2.181 1.131-2.663.901-.482-.23-1.904-1.83-1.98-2.537-.306-2.856 2.738-3.64 4.485-2.079Z",
    fill: "url(#moodmeter-settings-icon_svg__g)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.314 6.11c.75.087 4.649-1.896 2.738-2.927C4.947 1.506 1.097 3.84.742 7c-.201.953-.129 3.717.724 4.429 1.537 1.017 5.1.217 5.567-.889.001-.002-.002.007 0 .01-.685-1.733-1.235-3.195-.983-5.063",
    fill: "#FF0082"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m12.172 22.054-.004-.001a2.631 2.631 0 0 1-.244-.069c-.629-.216-2.975-.712-3.434-1.474-.986-1.637-.201-5.71-1.297-7.087-1.097-1.377-2.563-.142-2.838.716-.276.858.909 7 2.03 8.343 1.032 1.238 4.67 1.121 5.855 1.164.154.005.304.03.453.07.274.069.537.1.853.236.526.227.702 1.019.896 1.284a.263.263 0 0 0 .08.072c.162.094.369-.023.408-.206.336-1.575-.825-2.991-2.262-2.989a2.067 2.067 0 0 1-.496-.06Z",
    fill: "url(#moodmeter-settings-icon_svg__h)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__a",
    x1: 13.405,
    y1: 6.446,
    x2: 22.075,
    y2: 6.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#00AF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__b",
    x1: 12.334,
    y1: 6.904,
    x2: 20.984,
    y2: 6.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__c",
    x1: 5.716,
    y1: 12.432,
    x2: 15.905,
    y2: 13.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#612909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#AB4904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__d",
    x1: 1.293,
    y1: 44.929,
    x2: 2.857,
    y2: 44.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__e",
    x1: 4.595,
    y1: 46.125,
    x2: 6.153,
    y2: 46.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__f",
    x1: 2.747,
    y1: 4.66,
    x2: 10.181,
    y2: 17.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__g",
    x1: 3.557,
    y1: 13.374,
    x2: 7.691,
    y2: -0.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodmeter-settings-icon_svg__h",
    x1: 12.697,
    y1: 20.711,
    x2: 3.471,
    y2: 16.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612909"
  })))));
};
export { SvgMoodmeterSettingsIcon as ReactComponent };
export default __webpack_public_path__ + "91a0bc08fec5f0c97265033f7cc2dc54.svg";